// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/packages/v1/packages.proto" (package "viam.app.packages.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { PackageService } from "./packages";
import type { ListPackagesResponse } from "./packages";
import type { ListPackagesRequest } from "./packages";
import type { GetPackageResponse } from "./packages";
import type { GetPackageRequest } from "./packages";
import type { DeletePackageResponse } from "./packages";
import type { DeletePackageRequest } from "./packages";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreatePackageResponse } from "./packages";
import type { CreatePackageRequest } from "./packages";
import type { ClientStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service viam.app.packages.v1.PackageService
 */
export interface IPackageServiceClient {
    /**
     * CreatePackage uploads a package to the cloud
     *
     * @generated from protobuf rpc: CreatePackage(stream viam.app.packages.v1.CreatePackageRequest) returns (viam.app.packages.v1.CreatePackageResponse);
     */
    createPackage(options?: RpcOptions): ClientStreamingCall<CreatePackageRequest, CreatePackageResponse>;
    /**
     * DeletePackage removes the given package versions
     *
     * @generated from protobuf rpc: DeletePackage(viam.app.packages.v1.DeletePackageRequest) returns (viam.app.packages.v1.DeletePackageResponse);
     */
    deletePackage(input: DeletePackageRequest, options?: RpcOptions): UnaryCall<DeletePackageRequest, DeletePackageResponse>;
    /**
     * GetPackage returns the metadata for a requested package version. It also returns a URL
     * for downloading the package if one is requested.
     *
     * @generated from protobuf rpc: GetPackage(viam.app.packages.v1.GetPackageRequest) returns (viam.app.packages.v1.GetPackageResponse);
     */
    getPackage(input: GetPackageRequest, options?: RpcOptions): UnaryCall<GetPackageRequest, GetPackageResponse>;
    /**
     * ListPackages gets the metadata for the requested packages. Includes package name, version, and/or
     * type to filter beyond the required organization_id. ListPackages also returns URLs for
     * downloading each package if they are requested.
     *
     * @generated from protobuf rpc: ListPackages(viam.app.packages.v1.ListPackagesRequest) returns (viam.app.packages.v1.ListPackagesResponse);
     */
    listPackages(input: ListPackagesRequest, options?: RpcOptions): UnaryCall<ListPackagesRequest, ListPackagesResponse>;
}
/**
 * @generated from protobuf service viam.app.packages.v1.PackageService
 */
export class PackageServiceClient implements IPackageServiceClient, ServiceInfo {
    typeName = PackageService.typeName;
    methods = PackageService.methods;
    options = PackageService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * CreatePackage uploads a package to the cloud
     *
     * @generated from protobuf rpc: CreatePackage(stream viam.app.packages.v1.CreatePackageRequest) returns (viam.app.packages.v1.CreatePackageResponse);
     */
    createPackage(options?: RpcOptions): ClientStreamingCall<CreatePackageRequest, CreatePackageResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreatePackageRequest, CreatePackageResponse>("clientStreaming", this._transport, method, opt);
    }
    /**
     * DeletePackage removes the given package versions
     *
     * @generated from protobuf rpc: DeletePackage(viam.app.packages.v1.DeletePackageRequest) returns (viam.app.packages.v1.DeletePackageResponse);
     */
    deletePackage(input: DeletePackageRequest, options?: RpcOptions): UnaryCall<DeletePackageRequest, DeletePackageResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletePackageRequest, DeletePackageResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetPackage returns the metadata for a requested package version. It also returns a URL
     * for downloading the package if one is requested.
     *
     * @generated from protobuf rpc: GetPackage(viam.app.packages.v1.GetPackageRequest) returns (viam.app.packages.v1.GetPackageResponse);
     */
    getPackage(input: GetPackageRequest, options?: RpcOptions): UnaryCall<GetPackageRequest, GetPackageResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPackageRequest, GetPackageResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListPackages gets the metadata for the requested packages. Includes package name, version, and/or
     * type to filter beyond the required organization_id. ListPackages also returns URLs for
     * downloading each package if they are requested.
     *
     * @generated from protobuf rpc: ListPackages(viam.app.packages.v1.ListPackagesRequest) returns (viam.app.packages.v1.ListPackagesResponse);
     */
    listPackages(input: ListPackagesRequest, options?: RpcOptions): UnaryCall<ListPackagesRequest, ListPackagesResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPackagesRequest, ListPackagesResponse>("unary", this._transport, method, opt, input);
    }
}
